var React = require('react');

function IconFlutterDigital (props) {
    return React.createElement("svg",props,[React.createElement("g",{"id":"icomoon-ignore","key":0}),React.createElement("path",{"fill":"#000","d":"M523.642 0l-523.642 509.941 162.077 157.838 685.721-667.779h-324.156z","key":1}),React.createElement("path",{"fill":"#000","d":"M519.984 470.236l-280.373 273.040 162.687 160.796 445.495-433.836h-327.809z","key":2}),React.createElement("path",{"fill":"#000","d":"M402.222 904.067l123.156 119.933h322.334l-283.716-277.481-161.774 157.548z","key":3}),React.createElement("path",{"fill":"#000","d":"M237.722 745.051l162.081-157.844 164.205 159.317-161.774 157.548-164.511-159.022z","key":4}),React.createElement("path",{"fill":"#000","d":"M402.278 904.078l134.709-43.531 13.381-100.688-148.090 144.219z","key":5})]);
}

IconFlutterDigital.defaultProps = {"version":"1.1","width":"853","height":"1024","viewBox":"0 0 853 1024"};

module.exports = IconFlutterDigital;

IconFlutterDigital.default = IconFlutterDigital;
